import React from "react";
import video from "../assets/996699.mp4";
import "../App.css";

import { Achievements } from "../Components/Achievements";
import { Testimonials } from "../Components/Testimonials";
import { Services } from "../Components/Services";
import { Contact } from "../Components/Contact";
import { Footer } from "../Components/Footer";
import { Logos } from "../Components/Logos";
import { Works } from "../Components/Works";
import { Home } from "../Components/Home";
import { Nav } from "../Components/Nav";
import { texts } from "../data/langs";

export const LandingPage = () => {
  const videoRef = React.useRef(null);

  const [sttContact, setContact] = React.useState(false);

  React.useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 0.6; // 0.5x mais lento, use 2.0 para 2x mais rápido
    }

    const lang = texts.active;
    const title = texts[lang].title || "Morfos";
    document.title = title;
  }, []);

  return (
    <div className="App">
      {sttContact && <Contact setContact={setContact} />}

      <video autoPlay loop muted ref={videoRef}>
        <source src={video} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <Nav setContact={setContact} />

      <div className="GAP-10" />

      <Home setContact={setContact} />

      <div className="GAP-H100" />

      <Logos />

      <div className="GAP-H100" />

      <Services />

      <div className="GAP-H100" />

      <Testimonials />

      <div className="GAP-H100" />

      <Works />

      <div className="GAP-H100" />

      <Achievements />

      <div className="GAP-H100" />

      <Footer setContact={setContact} />
    </div>
  );
};
